<template>
    <div id="modal"></div>
    <div class="fixed w-full top-0 z-10">
        <div class="bg-next-neu lg:pl-next-nav">
            <TopNavigationBar></TopNavigationBar>
        </div>
<!--        <div class="pl-next-nav">-->
<!--            <div class="bg-white m-auto px-8 md:px-20">-->
<!--                <Topbar></Topbar>-->
<!--            </div>-->
<!--        </div>-->
    </div>
    <router-view name="nav"/>
    <div class="min-h-screen bg-next-light-gray" style="margin-top: calc( var(--top-navigation-height))"
         :class="[$route.name !== 'PermissionDenied' ? 'lg:ml-next-nav':'ml-0']">
        <router-view/>
    </div>
</template>

<style lang="scss">
@import "@/assets/css/tinymce.css";
@import "@/assets/css/app.css";
@import "@/assets/sass/app.scss";

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
<script setup lang="ts">
</script>
